// Copie dans le presse-papiers : API Clipboard, sinon repli sur execCommand
// (contexte non sécurisé, ex. préproduction en HTTP, ou permission refusée)
export async function copyText(text) {
  if (navigator.clipboard?.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // repli ci-dessous
    }
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '-1000px';
  textarea.style.opacity = '0';
  // select() déplace le focus : il revient ensuite à l'élément d'origine (clavier)
  const active = document.activeElement;
  document.body.appendChild(textarea);
  const selection = document.getSelection();
  const previousRange = selection?.rangeCount ? selection.getRangeAt(0) : null;
  textarea.select();

  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch {
    ok = false;
  }

  document.body.removeChild(textarea);
  if (previousRange && selection) {
    selection.removeAllRanges();
    selection.addRange(previousRange);
  }
  if (active && active !== document.body) active.focus?.({ preventScroll: true });
  return ok;
}
